import { CALENDAR_RAIL_SOURCES } from './CalendarRailSources.constants'

export function getIsCalendarRailSourceChecked({ source, sources }) {
  return sources.includes(source.id)
}

export function getCalendarRailNextSources({ isChecked, source, sources }) {
  return CALENDAR_RAIL_SOURCES.map(({ id }) => id).filter(id =>
    id === source ? isChecked : sources.includes(id)
  )
}
